import { gql } from '@apollo/client';

const schema = {
  update: {
    name: 'refundToWallet',
    serviceName: 'shopadmin',
    query: gql`
      mutation refundToWallet(
        $amount: String
        $type_id: String!
        $order_id: String!
        $description: String
        $product_shop_ids: [String]
      ) {
        refundToWallet(
          amount: $amount
          type_id: $type_id
          order_id: $order_id
          description: $description
          product_shop_ids: $product_shop_ids
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
